import { datesToISO } from "@";

// Function to fill bank entity form (edit bank name + image)
export const bankEntityFillForm = (bank) => ({
  id: bank.id,
  name: bank.name,
  image: null,
  imageFullUrl: bank.imageFullUrl,
  isActive: bank.isActive,
});

// Function to fill bank account form
export const bankFillForm = (item, bank) => ({
  bank,
  id: item.id,
  name: item.name,
  iban: item.iban,
  isDefault: item.isDefault,
});

// Function to fill classifications form
export const classificationsFillForm = (item) => ({
  id: item.id,
  Image: null,
  Name: item.name,
  Order: item.order,
  IsActive: item.isActive,
  imageFullUrl: item.imageFullUrl,
  bannerFullUrl: item.bannerFullUrl,
  ShowOnHomePage: item.showOnHomePage,
  ShowOnFastDonation: item.showOnFastDonation,
});

// Function to filter classifications based on search term
export const classificationsFilter = (data, search) => {
  const lowerCaseSearch = search.toLowerCase();
  return data.filter(({ name }) =>
    name.toLowerCase().includes(lowerCaseSearch),
  );
};

// Function to filter licenses based on search term
export const licensesFilter = (data, search) => {
  const lowerCaseSearch = search.toLowerCase();
  return data.filter(({ title, issuer, issueDate }) => {
    const titleMatch = title?.toLowerCase().includes(lowerCaseSearch);
    const issuerMatch = issuer?.toLowerCase().includes(lowerCaseSearch);
    const issueDateMatch = issueDate?.toLowerCase().includes(lowerCaseSearch);
    return titleMatch || issuerMatch || issueDateMatch;
  });
};

// Function to filter bank accounts based on search term
export const accountsFilter = (data, search) => {
  return data
    .map((bank) => {
      const filteredAccounts = bank.bankAccounts.filter(
        (account) =>
          account.name.includes(search) || account.iban.includes(search),
      );
      return { ...bank, bankAccounts: filteredAccounts };
    })
    .filter((bank) => bank.bankAccounts.length > 0);
};

// Function to fill info form
export const saveInfoPayload = (data) => ({
  ...data,
  CharityLogo: data.logo || "",
  LicenseNumber: data.licenseNumber || "",
  LicenseEndDate: datesToISO(data.licenseEndDate) || "",
});
